<div id="why" class="py-5">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h2 class="home-title text-center text-white">
                    WHY ARYAKULAM INTERNATIONAL SCHOOL IS <span>BEST</span> FOR STUDENTS?
                </h2>
                <p class="text-center text-white lead mb-5">
                    At ARYAKULAM International School, we are committed to providing an ecosystem where excellence meets character. 
                    Our core philosophy is built on five pillars that ensure every student achieves their highest potential.
                </p>
            </div>
        </div>

        <div class="row g-4 justify-content-center">
            <!-- 1. Sagacity -->
            <div class="col-12 col-md-6 col-lg-4">
                <div class="card pt-3 h-100 shadow-sm border-0">
                    <div class="card-body">
                        <div class="icon-container text-center">
                            <i class="fa-solid fa-graduation-cap"></i>
                        </div>
                        <h4 class="text-center text-white my-4">1. Sagacity</h4>
                        <p class="text-center">
                            At ARYAKULAM International School, wisdom-driven education forms the foundation of every learning experience. Through highly qualified educators, modern teaching methodologies, and value-based instruction, students gain not only academic knowledge but also thoughtful judgement, ethical awareness, and intellectual maturity.
                        </p>
                    </div>
                </div>
            </div>

            <!-- 2. Holism -->
            <div class="col-12 col-md-6 col-lg-4">
                <div class="card pt-3 h-100 shadow-sm border-0">
                    <div class="card-body">
                        <div class="icon-container text-center">
                            <i class="fa-solid fa-burst"></i>
                        </div>
                        <h4 class="text-center text-white my-4">2. Holism</h4>
                        <p class="text-center">
                            AIS embraces a holistic philosophy where academic rigor blends seamlessly with cultural, physical, and emotional development. With structured co-curricular programs, leadership through four vibrant houses, sports participation, and creative platforms, students evolve in every dimension.
                        </p>
                    </div>
                </div>
            </div>

            <!-- 3. Pedagogy -->
            <div class="col-12 col-md-6 col-lg-4">
                <div class="card pt-3 h-100 shadow-sm border-0">
                    <div class="card-body">
                        <div class="icon-container text-center">
                            <i class="fa-solid fa-chalkboard-user"></i>
                        </div>
                        <h4 class="text-center text-white my-4">3. Pedagogy</h4>
                        <p class="text-center">
                            The institution practices progressive pedagogy rooted in innovation and conceptual clarity. Smart classrooms, well-equipped laboratories, and experiential learning strategies ensure that students move beyond rote memorization to analytical thinking.
                        </p>
                    </div>
                </div>
            </div>

            <!-- 4. Sanctity -->
            <div class="col-12 col-md-6 col-lg-4">
                <div class="card pt-3 h-100 shadow-sm border-0">
                    <div class="card-body">
                        <div class="icon-container text-center">
                            <i class="fa-solid fa-shield-halved"></i>
                        </div>
                        <h4 class="text-center text-white my-4">4. Sanctity</h4>
                        <p class="text-center">
                            Safety, hygiene, and discipline remain paramount at AIS. With secure transportation, well-maintained medical facilities, hygienic surroundings, and attentive supervision, the campus provides a protected environment where children feel safe and confident.
                        </p>
                    </div>
                </div>
            </div>

            <!-- 5. Futurism -->
            <div class="col-12 col-md-6 col-lg-4">
                <div class="card pt-3 h-100 shadow-sm border-0">
                    <div class="card-body">
                        <div class="icon-container text-center">
                            <i class="fa-solid fa-rocket"></i>
                        </div>
                        <h4 class="text-center text-white my-4">5. Futurism</h4>
                        <p class="text-center">
                            AIS prepares students for tomorrow through futuristic infrastructure and diverse academic streams, including Medical, Non-Medical, Commerce, and Humanities. Career-oriented guidance and exposure to modern technology enable learners to adapt confidently to evolving global challenges.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>